import { toDateTimeTzString } from "@/lib/Formatters/toDateTimeString";
import dayjs from "dayjs";

export type TimePeriod = "week" | "month";

export const durationData: Record<
  TimePeriod,
  {
    periods: number;
    unit: dayjs.ManipulateType;
  }
> = {
  week: {
    periods: 7,
    unit: "day",
  },
  month: {
    periods: 30,
    unit: "day",
  },
};

export function getRelocationViewsVariables(
  relocationId: string,
  duration: TimePeriod,
) {
  const { periods, unit } = durationData[duration];

  const end = dayjs().local().endOf(unit);
  const start = end.clone().subtract(periods, unit);

  return {
    id: relocationId,
    start: toDateTimeTzString(start),
    end: toDateTimeTzString(end),
  };
}
